module.exports = __webpack_public_path__ + "img/swipe-horizontal.fd4c1692.png";